import React, {useState } from "react";
import { Modal, Typography, Button } from "@mui/material";

const FileUploadModal = ({ isOpen, onClose, onFileUpload }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isFileValid] = useState(false);

  const acceptedTypes = [
    "text/csv",
    "text/x-csv",
    "application/x-csv",
    "application/csv",
    "text/x-comma-separated-values",
    "text/comma-separated-values",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ];

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (acceptedTypes.includes(file.type)) {
      setSelectedFile(file);
    } else {
      setSelectedFile(null);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleUpload = () => {
    if (selectedFile) {
      onFileUpload(selectedFile);
      setSelectedFile(null);
      onClose();
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#FFF",
          padding: "20px",
          borderRadius: "4px",
        }}
      >
        <Typography variant="h6">Upload File</Typography>
        <input
          accept=".xlsx, .xls"
          type="file"
          required
          onChange={handleFileChange}
        />
        <div
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          style={{
            width: "300px",
            height: "200px",
            border: "2px dashed #aaa",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            margin: "20px 0",
          }}
        >
          {selectedFile ? (
            <p>Selected file: {selectedFile.name}</p>
          ) : (
            <p>Drag and drop an Excel file here</p>
          )}
        </div>
        <Button
          id="upload-trainings-button"
          variant="contained"
          onClick={handleUpload}
          disabled={!selectedFile && !isFileValid}
        >
          Upload
        </Button>
        <Button
          id="upload-trainings-cancel-button"
          variant="contained"
          onClick={onClose}
          style={{ marginLeft: "10px" }}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default FileUploadModal;
